import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
/**
 * Manages all things related to the Redux store required by UA modules.
 * @namespace UAReduxStore
 */

var store = /*#__PURE__*/function () {
  function store() {
    _classCallCheck(this, store);
  }

  _createClass(store, null, [{
    key: "configureStore",

    /**
     * A global reference to the store. Unlike universal-access-ui, there is no
     * connectors in the modules, therefore access to the store needs to happen
     * through the object itself. This allows modules to import and use the store
     * object.
     *
     * @memberof UAReduxStore
     */

    /**
     * Configure the UA Redux store.
     * If a store is passed, this store will be used, otherwise UA will create its
     * own store using the {@link UAReducers}.
     *
     * Note: the expectation is that the Redux store that is passed is primed using
     * the {@link UAReducers} to ensure it can operate with the UA
     *
     * @param {any} inputStore [optional] a Redux store that includes the UAReducers
     *
     * @memberof UAReduxStore
     */
    value: function configureStore(inputStore) {
      // a reference to the store that is passed from the wrapping application.
      this.internalStore = inputStore;

      if (!inputStore) {
        // Example of adding middlewares if required
        // const middlewares = [routerMiddleware(history)];
        var middlewares = []; // no middlewares for now

        var enhancers = [applyMiddleware.apply(void 0, middlewares)]; // If Redux DevTools Extension is installed use it, otherwise use Redux compose

        /* eslint-disable no-underscore-dangle */

        var composeEnhancers = process.env.NODE_ENV !== 'production' && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
        /* eslint-enable */

        this.internalStore = createStore(reducers, {}, // initial state
        composeEnhancers.apply(void 0, enhancers));
      }

      return this.internalStore;
    }
  }]);

  return store;
}();

_defineProperty(store, "internalStore", null);

export { store as default };